import DisasterRecovery from 'assets/icons/categories/disaster-recovery.svg';
import Technology from 'assets/icons/categories/technology.svg';
import Advocacy from 'assets/icons/categories/advocacy.svg';
import Animals from 'assets/icons/categories/animals.svg';
import Arts from 'assets/icons/categories/arts.svg';
import Children from 'assets/icons/categories/children.svg';
import Disabilities from 'assets/icons/categories/disabilities.svg';
import Education from 'assets/icons/categories/education.svg';
import Employment from 'assets/icons/categories/employment.svg';
import Environment from 'assets/icons/categories/environment.svg';
import FoodAccess from 'assets/icons/categories/food-access.svg';
import Health from 'assets/icons/categories/health.svg';
import Homelessness from 'assets/icons/categories/homelessness.svg';
import LGBTQ from 'assets/icons/categories/lgbtq.svg';
import MentalHealth from 'assets/icons/categories/mental-health.svg';
import Mentoring from 'assets/icons/categories/mentoring.svg';
import Politics from 'assets/icons/categories/politics.svg';
import Seniors from 'assets/icons/categories/seniors.svg';
import SportsRecreation from 'assets/icons/categories/sports-recreation.svg';
import Sustainability from 'assets/icons/categories/sustainability.svg';
import Veterans from 'assets/icons/categories/veterans.svg';
import Women from 'assets/icons/categories/women.svg';
import Youth from 'assets/icons/categories/youth.svg';
import SmileFallback from 'assets/icons/categories/smile-fallback.svg';

const iconMap = {
  advocacy: { icon: Advocacy, hexCode: '#DEB7AF' },
  animals: { icon: Animals, hexCode: '#EAC489' },
  arts: { icon: Arts, hexCode: '#F1C864' },
  children: { icon: Children, hexCode: '#FFBD73' },
  disabilities: { icon: Disabilities, hexCode: '#FFAD82' },
  disasterrecovery: { icon: DisasterRecovery, hexCode: '#FFA8A8' },
  education: { icon: Education, hexCode: '#FFB8A9' },
  employment: { icon: Employment, hexCode: '#FBD1BF' },
  environment: { icon: Environment, hexCode: '#FFAECA' },
  foodaccess: { icon: FoodAccess, hexCode: '#FF98E2' },
  health: { icon: Health, hexCode: '#DBAFFF' },
  homelessness: { icon: Homelessness, hexCode: '#C8B6FF' },
  lgbtq: { icon: LGBTQ, hexCode: '#E7C6FF' },
  mentalhealth: { icon: MentalHealth, hexCode: '#DBCBD8' },
  mentoring: { icon: Mentoring, hexCode: '#B0D3ED' },
  politics: { icon: Politics, hexCode: '#AEEFF1' },
  seniors: { icon: Seniors, hexCode: '#A2DADE' },
  sportsandrecreation: { icon: SportsRecreation, hexCode: '#B0C3D7' },
  sustainability: { icon: Sustainability, hexCode: '#CFE8F6' },
  technology: { icon: Technology, hexCode: '#9EEAD3' },
  veterans: { icon: Veterans, hexCode: '#A8D9C6' },
  women: { icon: Women, hexCode: '#B7DD8E' },
  youth: { icon: Youth, hexCode: '#CCD789' },
};
export interface IconData {
  icon: string;
  hexCode: string;
}

export const getCategoryIconData = (categories: string[]): IconData => {
  const categoriesWithIcons = Object.keys(iconMap);
  const category = categories.find((c) => categoriesWithIcons.includes(c));

  if (!category) {
    return {
      icon: SmileFallback,
      hexCode: '#BDA9FF',
    };
  }

  return iconMap[category as keyof typeof iconMap];
};
